import { IFloodgateTelemetryLogger, ITelemetryProperties, SurveyType, TreatmentType } from "@ms-ofb/floodgate-shared-typings";

// Telemetry logger with no-op logger
class DefaultFloodgateTelemetryLogger implements IFloodgateTelemetryLogger {
	// @Override
	public log_TriggerMet(
		campaignId: string, 
		surveyId: string, 
		surveyType: SurveyType, 
		surveyActivityInfo: string,
		additionalSurveyInfo: string, 
		treatmentType: TreatmentType, 
		isUxSchemaPresent: boolean): void { }

	// @Override
	public log_UserSelected(campaignId: string, surveyId: string, surveyType: SurveyType,
		additionalSurveyInfo: string, treatmentType: TreatmentType): void { }

	// @Override
	public log_CampaignLoad_Failed(errorMessage: string): void { }

	// @Override
	public log_Error(eventId: string, errorMessage: string): void { }

	// @Override
	public log_Event(eventId: string, properties: ITelemetryProperties): void { }

	// @Override
	public log_LocalError(message: string, ...data: any[]): void { }
}

export class TelemetryLogger {
    private static telemetryLogger: IFloodgateTelemetryLogger = new DefaultFloodgateTelemetryLogger();

    public static getTelemetryLogger(): IFloodgateTelemetryLogger {
        return TelemetryLogger.telemetryLogger;
    }

    public static setTelemetryLogger(logger: IFloodgateTelemetryLogger): void {
        if (!logger) {
            throw new Error("TelemetryLogger must not be null");
        }
        TelemetryLogger.telemetryLogger = logger;
    }
}